import { ApolloCache, gql } from '@apollo/client'
import isBefore from 'date-fns/isBefore'
import isAfter from 'date-fns/isAfter'

import { STATUS } from 'features/Campaigns/components/Status/constants'

export const getStatus = (campaign: TSFixMe): TSFixMe => {
  const now = new Date()

  if (isBefore(now, new Date(campaign.startsAt)) && campaign.isActive) {
    return STATUS.SCHEDULED
  }

  if (isAfter(now, new Date(campaign.endsAt)) && campaign.isActive) {
    return STATUS.EXPIRED
  }

  return campaign.isActive ? STATUS.ACTIVE : STATUS.INACTIVE
}

export const DEACTIVATE_LOCAL_SUBCAMPAIGN_COUPON = gql`
  mutation DeactivateLocalSubcampaignCoupon($id: ID!) {
    deactivateSubcampaignCoupon(id: $id) @client
  }
`

export const resolvers = {
  Mutation: {
    activateCampaign(_root: TSFixMe, { id }: { id: string }, { cache }: { cache: ApolloCache<TSFixMe> }): null {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'Campaign',
          id
        }),
        fragment: gql`
          fragment CampaignIsActive on Campaign {
            isActive
          }
        `,
        data: {
          isActive: true,
          __typename: 'Campaign'
        }
      })

      return null
    },
    deactivateCampaign(_root: TSFixMe, { id }: { id: string }, { cache }: { cache: ApolloCache<TSFixMe> }): null {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'Campaign',
          id
        }),
        fragment: gql`
          fragment CampaignIsActive on Campaign {
            isActive
          }
        `,
        data: {
          isActive: false,
          __typename: 'Campaign'
        }
      })

      return null
    },
    deactivateSubcampaignCoupon(
      _root: TSFixMe,
      { id }: { id: string },
      { cache }: { cache: ApolloCache<TSFixMe> }
    ): null {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'SubcampaignCoupon',
          id
        }),
        fragment: gql`
          fragment CouponIsActiveField on SubcampaignCoupon {
            isActive
          }
        `,
        data: {
          isActive: false,
          __typename: 'SubcampaignCoupon'
        }
      })

      return null
    }
  }
}
